import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
// import InfiniteCarousel from 'react-leaf-carousel';
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import './style/electedStyle.css';
import placeholder from "assets/img/bhaktapur/placeholder_person.png";

// Sections for this page
const useStyles = makeStyles(styles);

const method_of_election = {
  // directly_elected: 'प्रत्यक्ष निर्वाचित',
  // not_directly_elected: 'समानुपातिक',
  elected_from_parliament_directy: 'संघीय संसद, प्रतिनिधि सभा प्रत्यक्ष निर्वाचित',
  elected_from_parliament_directy_1: 'संघीय संसद, प्रतिनिधि सभा प्रत्यक्ष निर्वाचित, १',
  elected_from_parliament_directy_2: 'संघीय संसद, प्रतिनिधि सभा प्रत्यक्ष निर्वाचित, २',
  elected_from_parliament_proportionally: 'संघीय संसद, प्रतिनिधि सभा समानुपातिक',
  elected_from_parliament_assembly: 'संघीय संसद राष्ट्रिय सभा',
  elected_from_state_directly: 'प्रदेशसभा प्रत्यक्ष निर्वाचित',
  elected_from_state_directly_1_a: 'प्रदेशसभा प्रत्यक्ष निर्वाचित, १ क',
  elected_from_state_directly_1_b: 'प्रदेशसभा प्रत्यक्ष निर्वाचित, १ ख',
  elected_from_state_directly_2_a: 'प्रदेशसभा प्रत्यक्ष निर्वाचित, २ क',
  elected_from_state_directly_2_b: 'प्रदेशसभा प्रत्यक्ष निर्वाचित, २ ख',
  elected_from_state_proportionally: 'प्रदेश सभा समानुपातिक',
}

const representative_options = {
  'province': 'प्रदेशसभा सदस्य',
  'national': 'संघिय सांसद, राष्ट्रिय सभा',
  'union': 'संघिय सांसद, प्रतिनिधि सभा',
}

export default function ProductSection(props) {
  const classes = useStyles();

  const vip_list = [
    'district_head',
    'district_deputy_head',
    'mayor',
    'deputy_mayor',
    'e_district_head',
    'e_district_head_adhikari'
  ]
  const position_attrib = props.position_attrib

  let vip = props.data && props.data.map(people => {
    if (vip_list.includes(people[position_attrib])) {
      return (people)
    }
  })
  const non_vip = props.data && props.data.map(people => {
    if (!vip_list.includes(people[position_attrib])) {
      return (people)
    }
  })

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0 }}>
            <small>परिचय</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a' }}>{props.title}</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <GridContainer style={{ margin: 'auto' }}>
            {props.data &&
              <GridContainer style={{ margin: 'auto' }}>
                {vip.map(people => {
                  if (people) {
                    let image_link = placeholder
                    if (people.image) {
                      image_link = people.image
                    }
                    return (
                      <GridItem style={{ width: '220px' }}>
                        <Card>
                          <div style={{
                            marginBottom: '0', height: '200px',
                            backgroundColor: 'white', backgroundImage: "url(" + image_link + ")",
                            backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'center'
                          }}
                          />
                          <div style={{ minHeight: props.elected_representative ? '140px' : 'fit-content', fontFamily: 'nepali-font' }}>
                            <div className={classes.description} style={{ color: '#333', marginTop: '5px' }}>{people.name}</div>
                            {!props.elected_representative && <div className={classes.description} style={{ color: '#666', marginTop: '-8px' }}>{people.designation}</div>}
                            <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>सम्पर्क: {people.contact}</div>
                            {props.elected_representative && (people.elected_area_number !== '' && people.elected_area_number !== null && people.elected_area_number !== undefined) && <div className={classes.description} style={{ color: '#333', marginTop: '-8px', fontFamily: 'nepali-font' }}>निवाचित क्षेत्रनम्बर: {props.elected_representative && people.elected_area_number}</div>}
                            {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>({props.elected_representative && method_of_election[people.method_of_election]})</div>}
                            {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>{props.elected_representative && people.affiliated_political_party}</div>}
                            {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>{props.elected_representative && representative_options[people.representation]}</div>}
                          </div>
                        </Card>
                      </GridItem>
                    )
                  } else {
                    return (<div />)
                  }
                })}
              </GridContainer>
            }</GridContainer>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer style={{ margin: 'auto' }}>
            {props.data &&
              <GridContainer style={{ margin: 'auto' }}>
                {non_vip.map(people => {
                  if (people) {
                    let image_link = placeholder
                    if (people.image) {
                      image_link = people.image
                    }
                    return (
                      <GridItem style={{ width: '220px' }}>
                        <Card>
                          <div style={{
                            marginBottom: '0', height: '200px',
                            backgroundColor: 'white', backgroundImage: "url(" + image_link + ")",
                            backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'center'
                          }}
                          />
                          {/* <div style={{ minHeight: props.elected_representative ? '134px' : 'fit-content', fontFamily: 'nepali-font', textAlign: props.elected_representative ? 'left': '', marginLeft: props.elected_representative ? '10px': '', lineHeight: props.elected_representative ? '2' : '', fontSize: props.elected_representative ? '1rem': '' }}> */}
                          <div style={{fontFamily: 'nepali-font', minHeight: 'fit-content'}} className={props.elected_representative ? 'electedCustomStyle' : ''}>
                            <div className={classes.description} style={{ color: '#333', marginTop: '5px', fontWeight: props.elected_representative ? 'bold' : ''}}>{people.name}</div>
                            {!props.elected_representative && <div className={classes.description} style={{ color: '#666', marginTop: '-8px' }}>{people.designation}</div>}
                            <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>सम्पर्क: {people.contact}</div>
                            {props.elected_representative && (people.elected_area_number !== '' && people.elected_area_number !== null && people.elected_area_number !== undefined) && <div className={classes.description} style={{ color: '#333', marginTop: '-8px', fontFamily: 'nepali-font' }}>निवाचित क्षेत्रनम्बर: {props.elected_representative && people.elected_area_number}</div>}
                            {/* {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>({props.elected_representative && method_of_election[people.method_of_election]})</div>} */}
                            {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>{props.elected_representative && people.affiliated_political_party}</div>}
                            {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>{props.elected_representative && representative_options[people.representation]}</div>}
                          </div>
                        </Card>
                      </GridItem>
                    )
                  } else {
                    return (<div />)
                  }
                })}
              </GridContainer>
            }</GridContainer>
          {/*props.data && <InfiniteCarousel
            breakpoints={[
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
            ]}
            autoCycle={true}
            cycleInterval={3000}
            dots={false}
            showSides={true}
            sidesOpacity={1}
            sideSize={.1}
            slidesToScroll={1}
            slidesToShow={4}
            scrollOnDevice={true}
          >
            {props.data.map(people =>{
              let image_link = placeholder
              if (people.image) {
                image_link = people.image
              }
              return(<GridItem style={{ fontFamily: 'nepali-font' }}>
                <Card style={{
                  marginBottom: '0', height: '200px',
                  backgroundColor: 'white', backgroundImage: "url("+image_link+")",
                  backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'center' }}
                />
                <div className={classes.description} style={{ color: '#333', marginTop: '5px' }}>{people.name}</div>
                {!props.elected_representative && <div className={classes.description} style={{ color: '#666', marginTop: '-8px' }}>{people.designation}</div>}
                <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>सम्पर्क: {people.contact}</div>
                {props.elected_representative && (people.elected_area_number !== '' && people.elected_area_number !== null && people.elected_area_number !== undefined ) && <div className={classes.description} style={{ color: '#333', marginTop: '-8px', fontFamily: 'nepali-font' }}>निवाचित क्षेत्रनम्बर: {props.elected_representative && people.elected_area_number}</div>}
                {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>({props.elected_representative && method_of_election[people.method_of_election]})</div>}
                {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>{props.elected_representative && people.affiliated_political_party}</div>}
                {props.elected_representative && <div className={classes.description} style={{ color: '#333', marginTop: '-8px' }}>{props.elected_representative && representative_options[people.representation]}</div>}
              </GridItem>)
            })}
          </InfiniteCarousel>*/}
        </GridItem>
      </GridContainer>
    </div>
  );
}
